import { Link } from "@tanstack/react-router";
import logoSrc from "@/assets/lel-logo.png";
const logo = { url: logoSrc };

const focusRing =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background";

export function GrowHeader({ transparent = false }: { transparent?: boolean }) {
  return (
    <header
      className={
        transparent
          ? "absolute left-0 right-0 top-0 z-30 bg-transparent"
          : "relative z-30 border-b border-primary/10 bg-header/95 backdrop-blur-sm"
      }
    >
      <a
        href="#grow-main"
        className={`sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-3 focus:z-50 focus:rounded-[6px] focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-primary focus:shadow-brand ${focusRing}`}
      >
        Skip to main content
      </a>
      <div className="mx-auto grid max-w-5xl grid-cols-[minmax(0,1fr)_auto] items-center gap-3 px-5 py-2 sm:px-6 sm:py-3">
        <Link
          to="/grow/"
          aria-label="Leadership Edge Live home"
          className={`flex min-h-11 min-w-0 shrink-0 items-center rounded-md ${focusRing}`}
        >
          <img
            src={logo.url}
            alt="Leadership Edge Live"
            className="h-8 w-auto sm:h-9"
            {...(transparent ? { style: { filter: "brightness(0) invert(1)" } } : {})}
          />
        </Link>
        <nav aria-label="Primary" className="flex items-center gap-1 sm:gap-3">
          <Link
            to="/"
            className={`inline-flex min-h-11 items-center rounded-md px-2 text-xs transition-colors sm:text-sm ${transparent ? "text-white/80 hover:text-white" : "text-muted-foreground hover:text-primary"} ${focusRing}`}
          >
            For organizations
          </Link>
          <Link
            to="/start/"
            className={`inline-flex min-h-11 items-center rounded-[6px] bg-[#693D94] px-4 text-xs font-semibold text-primary-foreground shadow-brand transition-transform hover:-translate-y-0.5 sm:px-5 sm:text-sm ${focusRing}`}
          >
            Get started
          </Link>
        </nav>
      </div>
    </header>
  );
}

export function GrowFooter() {
  return (
    <footer className="mt-20 border-t border-border/60 bg-lavender">
      <div className="mx-auto max-w-5xl px-5 py-12 sm:px-6">
        <Link
          to="/grow/"
          aria-label="Leadership Edge Live home"
          className={`inline-flex min-h-11 items-center rounded-md ${focusRing}`}
        >
          <img src={logo.url} alt="Leadership Edge Live" className="h-9 w-auto" />
        </Link>
        <nav
          aria-label="Footer"
          className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm"
        >
          <Link
            to="/contact/"
            className={`inline-flex min-h-11 items-center rounded-md px-1 text-muted-foreground transition-colors hover:text-primary ${focusRing}`}
          >
            Contact
          </Link>
          <Link
            to="/"
            className={`inline-flex min-h-11 items-center rounded-md px-1 text-muted-foreground transition-colors hover:text-primary ${focusRing}`}
          >
            For organizations
          </Link>
        </nav>
        <p className="mt-6 text-xs text-muted-foreground">
          © {new Date().getFullYear()} Leadership Edge Live. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
